import { ReactElement } from 'react'
import ImageIcon from '@mui/icons-material/Image'
import { ToggleButton } from '@ui/actions'

interface Props {
  isAddPlanImageCardActive: boolean
  onToggleAddPlanImageCard: () => void
}

const PlanImageCardToolSelect = ({
  isAddPlanImageCardActive,
  onToggleAddPlanImageCard,
}: Props): ReactElement => (
  <ToggleButton
    hint="Plan-Bild hinzufügen"
    tooltipPlacement="top"
    size="small"
    onClick={onToggleAddPlanImageCard}
    selected={isAddPlanImageCardActive}
    Icon={ImageIcon}
    data-cy="btn-toggle-plan-image-card-place"
  />
)

export default PlanImageCardToolSelect
